module.exports = __webpack_public_path__ + "school/img/traditionDetailBg.f49bc7aa.jpg";